// @flow
import React, { useEffect, useMemo, useState } from 'react';
import { useLocation } from 'react-router';
import useGetFeature from '../hooks/useGetFeature';

const debug = require('debug')('jp:feature-by-location');

type FeatureRegexProps = {
  urlRegex: string,
  children: any
};
const FeatureRegex = ({ urlRegex, children }: FeatureRegexProps) => {
  const location = useLocation();
  const [enabled, setEnabled] = useState(false);
  const regex = useMemo(() => new RegExp(urlRegex, 'ig'), [urlRegex]);

  debug(urlRegex, location.pathname);

  useEffect(
    () => {
      const match = location.pathname.match(regex) !== null;

      setEnabled(match);
      debug(`URL match`, match);
    },
    [location.pathname, regex]
  );

  return enabled ? children : null;
};

type FeatureByLocationProps = {
  featureFlag: string,
  children: any
};

const FeatureByLocation = ({
  featureFlag,
  children
}: FeatureByLocationProps) => {
  const feature = useGetFeature(featureFlag);

  if (!feature || feature.enabled === false) {
    debug(`${featureFlag} disabled`);
    return null;
  }

  const urlRegex = feature.variantAttachment.url || '.+';
  return <FeatureRegex urlRegex={urlRegex}>{children}</FeatureRegex>;
};

export default FeatureByLocation;
